<template>
  <div>
    <div v-if="disconnected">
        <h3>연결이 끊겼습니다.</h3>
    </div>
    <div v-if="loading">
      <h3 style="font-weight:bold; font-size: 1.2em;" class="mt-1">
          <b-spinner variant="warning" label="Spinning" class="mt-1"></b-spinner>
          <br><br>
          <b>잠시만 기다려 주세요...</b>
          <br>
      </h3>
    </div>
    <div v-show="deviceLogList">
      <div class="justify-content-between align-items-center">
        <b-button variant="primary" class="w-100" @click="deviceLogList = null">
          {{ deviceLogName }} 동작 정보 ( 뒤로가기 )
        </b-button>
      </div>
      <b-table :items="deviceLogList" :fields="tableFields" bordered striped small per-page=15>
      </b-table>
    </div>
    <div v-if="!loading && status && !deviceLogList">
      <b-card v-if="alram">
        <b-row>
          <b-col>{{ alram.title }}</b-col>
          <b-col>{{ alram.message }}</b-col>
        </b-row>
      </b-card>
      <div> 
        <b-card style="border: ridge;" class="m-0">
          <b-row>
            <b-col>외부</b-col>
            <b-col>내부</b-col>
          </b-row>
          <b-row>
            <!-- <b-col style="font-size: x-large">외부 : </b-col> -->
            <b-col><b style="color: red;">{{ status['sensor:status:outTemp'] || '-' }} ℃</b></b-col>
            <b-col><b style="color: blue;">{{ status['sensor:status:outHumi'] || '-'}} ％</b></b-col>
            <!-- <b-col style="font-size: x-large">내부 : </b-col> -->
            <b-col><b style="color: red;">{{ status['sensor:status:inTemp'] || '-' }} ℃</b></b-col>
            <b-col><b style="color: blue;">{{ status['sensor:status:inHumi'] || '-' }} ％</b></b-col>
          </b-row>
        </b-card>
      </div>
      <b-row v-for="device of devices" :key="device.name">
          <b-col colspan="12">
              <b-card
              class="m-0"
                  style="
                      background-color: white; 
                      border: ridge; 
                      font-weight: bold;
                      font-size: large;
                      color: black;
                  ">
                  <table
                  style="width: -webkit-fill-available; border-spacing: 0.12rem">
                      <tr>
                          <td 
                          @click="showDeviceLogs(device)"
                          
                          colspan="2">
                              <b class="rounded border border-1 bg-light-primary ">{{ device.name }}</b>
                          </td>
                          <td v-if=" (status['device:info:autoMode'].auto && realMainDevice.includes(device.type)) || ((device.name.includes('분무제어') || device.name.includes('컴프레서')) && status['device:info:autoMode'].command)" colspan="2" style="width: 50%;">
                              <div class="w-100 disabled bg-info rounded border border-1" style="background-color: var(--bs-info); color: #000;">
                                  오토모드
                              </div>
                          </td>
                          <div v-else>
                            <td  colspan="1" style="width: 25%;" >
                                <b-button 
                                :disabled="!device.active"
                                @click="clickBtn(device, 'auto', true)"
                                :class="`w-100 btn btn-${device.auto? 'success inactive': 'secondary active'}`">
                                    자동
                                </b-button>
                            </td>
                            <td colspan="1" style="width: 25%">
                                <b-button 
                                :disabled="!device.active"
                                @click="clickBtn(device, 'auto', false)"
                                :class="`w-100 btn btn-${device.auto? 'secondary active': 'warning inactive'}`">
                                    수동
                                </b-button>
                            </td>
                          </div>
                      </tr>
                      <tr style="margin-top: 0.5rem;">
                          <td colspan="2" style="width: 50%;" >
                              <b-button 
                                size="lg" 
                                @click="clickBtn(device, 'command', true)"
                                :disabled="Boolean(device.auto) || Boolean(device.command) 
                                || (!device.name.includes('전동밸브') 
                                    && Boolean(status['device:info:autoMode'].auto)) 
                                || ((device.name.includes('분무제어') 
                                      || device.name.includes('컴프레서')) 
                                      && Boolean(status['device:info:autoMode'].command))"
                                :class="`w-100 btn-${Boolean(device.command)? 'success active': 'secondary inactive'}`"
                              > ON </b-button>
                          </td>
                          <td colspan="2" style="width: 50%">
                              <b-button 
                                size="lg" 
                                @click="clickBtn(device, 'command', false)"
                                :disabled="Boolean(device.auto) || Boolean(!device.command)
                                || (!device.name.includes('전동밸브') 
                                    && Boolean(status['device:info:autoMode'].auto)) 
                                || ((device.name.includes('분무제어') 
                                      || device.name.includes('컴프레서')) 
                                      && Boolean(status['device:info:autoMode'].command))"
                                :class="`w-100 btn-${Boolean(device.command)? 'secondary inactive': 'danger active'}`"
                              > OFF </b-button>
                          </td>
                      </tr>
                      <tr v-show="!findAlert(device.name)">
                        <th colspan="4" :style="{backgroundColor: showDeviceStatus(device.status).color }">
                          - {{showDeviceStatus(device.status).text}} -
                        </th>
                        
                      </tr>
                      <tr v-show="findAlert(device.name)">
                        <th colspan="4" style="background-color: yellow;">
                          {{ findAlert(device.name) }}
                        </th>
                      </tr>
                  </table>
              </b-card>
            </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { 
    BFormCheckbox,
    BButtonGroup,
    BInputGroup,
    BFormInput,
    BButton,
    BTable,
    BSpinner,
    BCard,
    BBadge,
    BRow,
    BCol,
} from 'bootstrap-vue'
import { io } from "socket.io-client";
import { getUserData } from '@/auth/utils'
import store from '@/store'
import dayjs from 'dayjs'

export default {
  components: {
        BFormCheckbox,
        BButtonGroup,
        BInputGroup,
        BFormInput,
        BButton,
        BTable,
        BSpinner,
        BCard,
        BBadge,
        BRow,
        BCol,
    },
    props: {
        buttonItem: {
            type: Object,
            required: true,
        }
    },
  data() {
    return {
      socket: null,
      serverMessage: "",
      disconnected: false,
      status: null,
      loading: false,
      alram: null,
      alramMessage: null,
      devices: [],
      deviceLogName: null,
      deviceLogList: null,
      realMainDevice: ['sprayer', 'compressor'],
      tableFields: [
        // {
        //   key: 'device_type',
        //   label: '장치명',
        //   formatter: (value, key, item) => {
        //     return this.getDeviceName(value)
        //   }
        // },
        {
          key: 'mode',
          label: '모드',
          formatter: (value) => {
            switch (value) {
              case 'manual': return '수동'
              case 'autoMode': return '오토모드'
              case 'auto': return '자동'
              default: return '미등록'
            }
          }
        },
        {
          key: 'command',
          label: '동작',
          formatter: (value) => {
            return value == 1 ? 'ON' : 'OFF'
          }
        },
        {
          key: 'timestamp',
          label: '날짜',
          formatter: (value) => this.getTimestamp(value)
        }
      ]
    };
  },
  created() {
    
    this.initSocket()
    
    // 🔹 브라우저 visibility 이벤트 등록
    document.addEventListener("visibilitychange", this.handleVisibility)
  },
  beforeDestroy() {
    if (this.socket) this.socket.disconnect()
    document.removeEventListener("visibilitychange", this.handleVisibility)
  },
  methods: {
    getStatus(state) {
      switch(state) {
        case 'working': return '작동중'
        case 'stopped': return '정지'
        case 'charging': return '충전중'
        
        default: return '대기'
      }
    },
    // ✅ 소켓 초기화 함수
    async initSocket() {
      this.loading = true
      this.socket = io(
        window.location.protocol === "https:"
          ? "wss://app.e-farm.site"
          : "ws://127.0.0.1:3007",
        { 
          transports: ["websocket"],
          path: "/socket.io/",
        }
      );
      this.socket.on("connect", async () => {
        const dataIntegration = await this.getRegistNo()
        this.socket.emit("requestDeviceConnect", { data: {
          _id: this.buttonItem._id,
          userId: getUserData().phone,
          url: this.buttonItem.url,
          registNo: dataIntegration.lsind_regist_no,
          makrId: dataIntegration.make_id,
          itemCode: dataIntegration.item_code,
          stallTyCode: dataIntegration.stall_type_code
        } });
      });

      this.socket.on('getDeviceReport', async res => {
        const res1 = res.filter( e => this.getDeviceName(e.device_type) === this.deviceLogName)
        this.deviceLogList = res1
      })

      this.socket.on("errPage", () => {
        this.disconnected = true
      });

      this.socket.on("status", (data) => {
        this.loading = false
        if(!data['board:connect']) this.disconnected = true
        else this.disconnected = false
        this.status = data
        this.devices = []
        // this.devices.push(data[`sensor:info:outTemp`])
        // this.devices.push(data[`sensor:info:outHumi`])
        // this.devices.push(data[`sensor:info:inTemp`])
        // this.devices.push(data[`sensor:info:inHumi`])
        this.devices.push(data[`device:info:autoMode`])
        this.devices.push(data[`device:info:sprayer`])
        this.devices.push(data[`device:info:compressor`])
        this.devices.push(data[`device:info:electricValve1`])
        this.devices.push(data[`device:info:electricValve2`])
        this.devices.push(data[`device:info:electricValve3`])
        this.devices.push(data[`device:info:electricValve4`])
        this.alram = data['alram:info']
        //if(this.alram) this.alramMessage = data['alram:info']
      });
    },
    clickBtn(device, type, val) {
      if(type === 'auto') return this.socket.emit('sprayer_conrol', { type: 'auto', name: device.type, val })    
      if(type === 'command' && !device.type.includes('electric')) return this.socket.emit('sprayer_conrol', { type: 'command',  name: device.type, val})
      if(type === 'command' && device.type.includes('electric')) {
        const idx = device.type.replace('electricValve', '')
        return this.socket.emit('sprayer_conrol', { type: 'eletricCommand',  name: idx , val})
      }

    },

    // ✅ 브라우저 탭/앱의 포그라운드 ↔ 백그라운드 상태 관리
    handleVisibility() {
      if (document.hidden) {
        // 🔻 백그라운드 전환 시 소켓 끊기
        if (this.socket) {
          this.socket.disconnect()
          console.log("Background ON.. socket pause")
        }
      } else {
        // 🔺 다시 포그라운드로 돌아왔을 때 소켓 재연결
        console.log("Reconnect Socket...!")
        this.initSocket()
      }
    },
    showDeviceStatus(status) {
      switch(status) {
        case 'stopped': return {text: '정지', color: 'orange'}
        case 'open': return {text: '열림중', color: 'lime'}
        case 'close': return {text: '닫힘중', color: 'tomato'}
        case 'working': return {text: '동작중', color: 'lightGreen'}
        case 'charging': return {text: '충전중', color: 'skyblue'}
        case 'ready': return {text: '준비중', color: 'lightgray'}
        default: return {text: '알림', color: 'yellow'}
      }
    },
    getDeviceName (deviceType) {
      switch (deviceType) {
        case 'autoMode': return '오토모드'
        case 'sprayer': return '분무제어'
        case 'compressor': return '컴프레서'
        case 'electricValve1': return '전동밸브 1번'
        case 'electricValve2': return '전동밸브 2번'
        case 'electricValve3': return '전동밸브 3번'
        case 'electricValve4': return '전동밸브 4번'
        default: return '미등록'
      }
    },
    getTimestamp (date) {
      return dayjs(date).format('YYYY-MM-DD HH:mm')
    },
    showDeviceLogs(device) {
      this.deviceLogName = device.name
      this.socket.emit("getDeviceReport", device) 
    },
    findAlert(ID) {
      const alert = this.alertList?.find(e => e.ID === ID)
      return alert ? alert.msg : null
    },
    async getRegistNo() {
      const res = await store.dispatch('users/fetchUser', { id: getUserData().id })
      return res.data.dataIntegration
    }
  },
}
</script>
